import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { API, setToken } from "@/lib/auth";
import { LOGO } from "@/data/site";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.access_token);
      toast.success("Welcome back, " + data.name);
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-white/20 text-white px-0 py-3 focus:outline-none focus:border-[#D4AF37] rounded-none placeholder:text-neutral-600 transition-colors";

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="absolute inset-0 grain opacity-[0.05] pointer-events-none" />
      <div className="relative w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src={LOGO} alt="AS Auto Works" className="h-20 w-auto object-contain" />
          <div className="mt-4 flex items-center gap-2 text-gold">
            <Lock size={14} />
            <span className="text-xs tracking-[0.3em] uppercase font-mono-x">Admin Access</span>
          </div>
        </div>

        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-[11px] uppercase tracking-widest text-neutral-500">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@asautoworks.com" className={inputCls} />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-widest text-neutral-500">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
          </div>
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 bg-gold text-black font-bold uppercase tracking-widest text-sm px-9 py-4 hover:bg-[#C5A028] transition-colors border border-[#D4AF37] disabled:opacity-60"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : null}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center text-xs text-neutral-600 mt-8">AS Auto Works · Lead Management</p>
      </div>
    </div>
  );
}
